module.exports = __webpack_public_path__ + "static/media/Logo.24924378.png";